(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nexo-showcase"]) return;
  try {
    
  (function () {
    var numbers = document.querySelectorAll('.nexo-showcase .nexo-showcase__stat-number');
    if (!numbers.length) return;

    function easeOutCubic(t) {
      return 1 - Math.pow(1 - t, 3);
    }

    function animateCount(el) {
      var target = parseFloat(el.getAttribute('data-count-to'));
      var fromAttr = el.getAttribute('data-count-from');
      var from = fromAttr !== null ? parseFloat(fromAttr) : 0;
      var decimals = parseInt(el.getAttribute('data-decimals') || '0', 10);
      var sep = el.getAttribute('data-decimal-sep');
      var duration = 1100;
      var startTime = null;

      function step(timestamp) {
        if (startTime === null) startTime = timestamp;
        var progress = Math.min((timestamp - startTime) / duration, 1);
        var value = from + (target - from) * easeOutCubic(progress);
        var text = value.toFixed(decimals);
        if (sep && sep !== '.') {
          text = text.replace('.', sep);
        }
        el.textContent = text;
        if (progress < 1) {
          requestAnimationFrame(step);
        }
      }
      requestAnimationFrame(step);
    }

    var animated = new WeakSet();
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting && !animated.has(entry.target)) {
          animated.add(entry.target);
          animateCount(entry.target);
        }
      });
    }, { threshold: 0.1 });

    numbers.forEach(function (el) { io.observe(el); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nexo-stack"]) return;
  try {
    
  (function () {
    document.querySelectorAll('.nexo-dose-fill').forEach(function (el) {
      var target = parseFloat(el.getAttribute('data-target'));
      var max = parseFloat(el.getAttribute('data-max'));
      el.style.width = Math.min(100, (target / max * 100)) + '%';
    });

    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduced) {
      document.querySelectorAll('.nexo-dose-fill').forEach(function (el) { el.classList.add('is-filled'); });
      return;
    }

    var rows = document.querySelectorAll('.nexo-stack .nexo-dose-row');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var fill = entry.target.querySelector('.nexo-dose-fill');
        if (entry.isIntersecting) {
          fill.classList.add('is-filled');
        }
      });
    }, { threshold: 0.4 });
    rows.forEach(function (row) { io.observe(row); });
  })();

  } catch(e) { console.error(e); }
})();
})();
